

















































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import VueScrollTo from 'vue-scrollto';
import Navbar from '@/components/NavBar';
import Hero from '@/components/Hero.vue';
import ScrollDownButton from '@/components/ScrollDownButton.vue';
import ShareButton from '@/components/Shared/buttons/ShareButton.vue';
import SubscribeButton from '@/components/Shared/SubscribeButton.vue';
import {CategoryModel} from '@/models/category.model';
import {TimelineLite} from 'gsap';

@Component({
  components: {
    Navbar,
    Hero,
    ScrollDownButton,
    ShareButton,
    SubscribeButton,
  },
})
export default class CategoriesHeader extends Vue {
  @Prop({required: true})
  category!: CategoryModel;

  goToChallenges() {
    VueScrollTo.scrollTo('#view-list', 800, {offset: -120});
  }

  @Watch('category')
  animate(v: CategoryModel) {
    const {content} = this.$refs;
    if (content) {
      const tl = new TimelineLite();
      tl.to(content, .3, {scale: 1.2, opacity: 0});
      tl.to(content, .3, {scale: 1, opacity: 1});
    }
  }
}

